module.exports = __webpack_public_path__ + "media/images/vp/icon.submenu.stats.red-0eb11b1af3b528d248237e303cc1f703.svg";